// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stHype_staking_container {
    /* padding: 20px;
    background-color: #f5f6fa; */
    min-height: 100vh;
    width: 100%;
}

.stHype_staking_content {
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: minmax(300px, 1fr) 2fr;
    gap: 24px;
    padding: 20px;
}

.stHype_staking_card_section {
    position: sticky;
    top: 20px;
    height: fit-content;
}

.stHype_staking_table_section {
    background-color: #ffffff;
    border: 1px solid black;
    overflow: hidden;
    padding: 6px 0;
    height: fit-content;
}

.stHype_staking_table_header {
    padding: 16px 24px;
    border-bottom: 1px solid black;
}

.stHype_staking_table_header h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
}

.stHype_staking_table_container {
    padding: 0;
    overflow: auto;
    max-height: calc(100vh - 200px);
}

.stHype_staking_table {
    width: 100%;
    border-collapse: collapse;
}

.stHype_staking_table th {
    padding: 12px 24px;
    background: white;
    text-align: left;
    position: sticky;
    top: 0;
    z-index: 1;
    border-bottom: 1px solid #e1e5eb;
}

.stHype_staking_table th:hover {
    background: rgb(241, 241, 241);
}

.stHype_staking_table td {
    padding: 12px 24px;
    border-bottom: 1px solid #e1e5eb;
    font-family: monospace;
    font-size: 14px;
}

.stHype_staking_address {
    font-family: monospace;
    color: #002475;
}

.stHype_staking_table tr:hover {
    background-color: rgba(0, 0, 0, 0.02);
}

.stHype_staking_loading,
.stHype_staking_error {
    padding: 24px;
    text-align: center;
    color: #002475;
}

.stHype_staking_pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    border-top: 1px solid #e1e5eb;
    gap: 16px;
    background-color: #ffffff;
    position: sticky;
    bottom: 0;
}

.stHype_staking_pagination_button {
    padding: 8px 16px;
    border: 1px solid black;
    border-radius: 4px;
    background: none;
    cursor: pointer;
    transition: all 0.2s ease;
}

.stHype_staking_pagination_button:hover:not(:disabled) {
    background-color: rgba(0, 36, 117, 0.05);
    color: #ffffff;
}

.stHype_staking_pagination_button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.stHype_staking_page_info {
    font-size: 14px;
}

@media (max-width: 1024px) {
    .stHype_staking_content {
        grid-template-columns: 1fr;
    }

    .stHype_staking_card_section {
        position: static;
    }
}

@media (max-width: 768px) {
    /* .stHype_staking_container {
        padding: 10px;
    } */

    .stHype_staking_content {
        padding: 10px;
    }

    .stHype_staking_table td,
    .stHype_staking_table th {
        padding: 12px 16px;
        font-size: 13px;
    }

    .stHype_staking_address {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/stHype/staking/tokenStakingPage.css"],"names":[],"mappings":"AAAA;IACI;gCAC4B;IAC5B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,6CAA6C;IAC7C,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;;OAEG;;IAEH;QACI,aAAa;IACjB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ","sourcesContent":[".stHype_staking_container {\n    /* padding: 20px;\n    background-color: #f5f6fa; */\n    min-height: 100vh;\n    width: 100%;\n}\n\n.stHype_staking_content {\n    max-width: 1400px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: minmax(300px, 1fr) 2fr;\n    gap: 24px;\n    padding: 20px;\n}\n\n.stHype_staking_card_section {\n    position: sticky;\n    top: 20px;\n    height: fit-content;\n}\n\n.stHype_staking_table_section {\n    background-color: #ffffff;\n    border: 1px solid black;\n    overflow: hidden;\n    padding: 6px 0;\n    height: fit-content;\n}\n\n.stHype_staking_table_header {\n    padding: 16px 24px;\n    border-bottom: 1px solid black;\n}\n\n.stHype_staking_table_header h2 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.stHype_staking_table_container {\n    padding: 0;\n    overflow: auto;\n    max-height: calc(100vh - 200px);\n}\n\n.stHype_staking_table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.stHype_staking_table th {\n    padding: 12px 24px;\n    background: white;\n    text-align: left;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    border-bottom: 1px solid #e1e5eb;\n}\n\n.stHype_staking_table th:hover {\n    background: rgb(241, 241, 241);\n}\n\n.stHype_staking_table td {\n    padding: 12px 24px;\n    border-bottom: 1px solid #e1e5eb;\n    font-family: monospace;\n    font-size: 14px;\n}\n\n.stHype_staking_address {\n    font-family: monospace;\n    color: #002475;\n}\n\n.stHype_staking_table tr:hover {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n.stHype_staking_loading,\n.stHype_staking_error {\n    padding: 24px;\n    text-align: center;\n    color: #002475;\n}\n\n.stHype_staking_pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 16px;\n    border-top: 1px solid #e1e5eb;\n    gap: 16px;\n    background-color: #ffffff;\n    position: sticky;\n    bottom: 0;\n}\n\n.stHype_staking_pagination_button {\n    padding: 8px 16px;\n    border: 1px solid black;\n    border-radius: 4px;\n    background: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.stHype_staking_pagination_button:hover:not(:disabled) {\n    background-color: rgba(0, 36, 117, 0.05);\n    color: #ffffff;\n}\n\n.stHype_staking_pagination_button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.stHype_staking_page_info {\n    font-size: 14px;\n}\n\n@media (max-width: 1024px) {\n    .stHype_staking_content {\n        grid-template-columns: 1fr;\n    }\n\n    .stHype_staking_card_section {\n        position: static;\n    }\n}\n\n@media (max-width: 768px) {\n    /* .stHype_staking_container {\n        padding: 10px;\n    } */\n\n    .stHype_staking_content {\n        padding: 10px;\n    }\n\n    .stHype_staking_table td,\n    .stHype_staking_table th {\n        padding: 12px 16px;\n        font-size: 13px;\n    }\n\n    .stHype_staking_address {\n        max-width: 120px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
